import React, { useEffect, useMemo, useState } from 'react'
import { observer } from 'mobx-react'
import { memberMobx } from '@mobxStore'
import { useHistoryListen, useHistoryNew } from '@utils'
import { Icon } from '@cps'
import { each } from '@dt/fe-utils/dist/lodash'
import ThirdCouponBar from '../ThirdCouponBar'
import './index.scss'

interface IProps {
  showTC?: boolean;
}

const CouponBar: React.FC<IProps> = ({ showTC }) => {
  const history = useHistoryNew()
  const { unacquiredCoupons, getUnacquiredCoupons, couponListForUse } = memberMobx
  const [unacquiredCnt, setUnacquiredCnt] = useState<number>(0)

  const handleGoCoupon = () => {
    history.push(unacquiredCnt ? '/iCoupon/coupon/get' : '/iCoupon')
  }
  // 是否有优惠券
  const hasCoupon = useMemo(() => {
    return memberMobx.isLogin && memberMobx.couponList?.length
  }, [memberMobx.isLogin, memberMobx.couponList?.length])

  useEffect(() => {
    if (unacquiredCoupons.length > 0) {
      const couponIds: any[] = []
      const couponArr: any[] = []
      let couponCnt: number = 0
      each(unacquiredCoupons, (item: any) => {
        each(item.coupons, (cItem: any) => {
          if (!couponIds.includes(cItem.couponId)) {
            couponIds.push(cItem.couponId)
          }
          for (let i = 0; i < cItem.couponCnt; i++) {
            couponArr.push({
              couponId: cItem.couponId
            })
          }
          couponCnt += cItem.couponCnt
        })
      })
      setUnacquiredCnt(couponCnt)
    } else {
      setUnacquiredCnt(0)
    }
  }, [unacquiredCoupons])

  useEffect(() => {
    if (!memberMobx.isUnacquiredInit && memberMobx.token) {
      getUnacquiredCoupons()
    }
  }, [])

  useHistoryListen((pathname: string) => {
    if (pathname === '/menu') {
      if (!memberMobx.isUnacquiredInit && memberMobx.token) {
        getUnacquiredCoupons()
      }
    }
  })

  if (!hasCoupon) return null

  return (
    <div className='bt-fill-btn-wrap'>
      <div className='coupon-bar-element-wrapper'>
        <div className='coupon-bar-element' data-cypid='click-coupon-bar' onClick={handleGoCoupon}>
          <div className='bt-icon'>
            <Icon name='quan' />
          </div>
          {unacquiredCnt > 0 && <div className='name-cnt'>{unacquiredCnt}</div>}
          <div className='name'>{unacquiredCnt > 0 ? i18n.t('menu.toBeGet') : `x${couponListForUse?.length}`}</div>
        </div>
        {showTC && <ThirdCouponBar showWrap={false} />}
      </div>
    </div>
  )
}

export default observer(CouponBar)
